import { useEffect, useState } from "react";
import flecha_izq from "../../assets/imgs/sobre_mi/flecha_izq.png";
import flecha_der from "../../assets/imgs/sobre_mi/flecha_der.png";
import Captura_1 from "../../assets/imgs/sobre_mi/Captura_1.png";
import Captura_2 from "../../assets/imgs/sobre_mi/Captura_2.png";
import Captura_3 from "../../assets/imgs/sobre_mi/Captura_3.png";
import Captura_4 from "../../assets/imgs/sobre_mi/Captura_4.jpg";
import Captura_5 from "../../assets/imgs/sobre_mi/Captura_5.jpg";
import Captura_6 from "../../assets/imgs/sobre_mi/Captura_6.jpg";
import Captura_7 from "../../assets/imgs/sobre_mi/Captura_7.jpg";
import Captura_8 from "../../assets/imgs/sobre_mi/Captura_8.jpg";
// import "./slider.css";

const Slider = ({ openVideoPopup, t }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const [activo, setActivo] = useState(1);

  const nextSlides = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % dataAnecdotas.length);
  };

  const prevSlides = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? dataAnecdotas.length - 1 : prevIndex - 1
    );
  };

  const dataAnecdotas = [
    {
      id: "SB_card_1",
      // img: "/static/media/Captura_1.7110ec81be877c72a476.png",
      img: Captura_1,
      video: "https://www.youtube.com/embed/UgJ02kn8Nwo",
      title: "idea_1",
    },
    {
      id: "SB_card_2",
      // img: "/static/media/Captura_2.d34131d646e5eaffecfa.png",
      img: Captura_2,
      video: "https://www.youtube.com/embed/1L9TrMGOJ30",
      title: "idea_2",
    },
    {
      id: "SB_card_3",
      // img: "/static/media/Captura_3.13c74ba94660c868a3df.png",
      img: Captura_3,
      video: "https://www.youtube.com/embed/cAbNd-6knFQ",
      title: "idea_3",
    },
    {
      id: "SB_card_4",
      // img: "/static/media/Captura_3.13c74ba94660c868a3df.png",
      img: Captura_4,
      video: "https://www.youtube.com/embed/Cgg054PSeuQ",
      title: "idea_4",
    },
    {
      id: "SB_card_5",
      // img: "/static/media/Captura_2.d34131d646e5eaffecfa.png",
      img: Captura_5,
      video: "https://www.youtube.com/embed/tuMZluuYEKA",
      title: "idea_5",
    },
    {
      id: "SB_card_6",
      // img: "/static/media/Captura_1.7110ec81be877c72a476.png",
      img: Captura_6,
      video: "https://www.youtube.com/embed/N4rTqqzMY2w",
      title: "idea_6",
    },
    {
      id: "SB_card_7",
      // img: "/static/media/Captura_1.7110ec81be877c72a476.png",
      img: Captura_7,
      video: "https://www.youtube.com/embed/7q_Az1lrW3U",
      title: "idea_7",
    },
    {
      id: "SB_card_8",
      img: "/static/media/Captura_1.7110ec81be877c72a476.png",
      img: Captura_8,
      video: "https://www.youtube.com/embed/H0cFmXzOaTE",
      title: "idea_8",
    },
  ];

  // Determina cuántos elementos se deben mostrar en función del tamaño de la pantalla
  const itemsToShow =
    window.innerWidth <= 768
      ? [currentIndex, currentIndex + 1]
      : [currentIndex, currentIndex + 1, currentIndex + 2];

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setActivo(Math.ceil((currentIndex + 1) / 2));
      } else {
        setActivo(1);
      }
    };

    window.addEventListener("resize", handleResize);
  }, [itemsToShow]);

  const totalPages = Math.ceil(dataAnecdotas.length / 2);
  const pages = Array.from({ length: totalPages }, (_, index) => index + 1);

  const indices = [];
  let i = 0;
  for (let index = 1; index <= totalPages; index++) {
    indices.push(i);
    i += 2;
  }

  const goToPage = (pageNumber) => {
    setCurrentIndex(indices[pageNumber - 1]);
    setActivo(pageNumber);
  };

  const nextSlides2 = () => {
    let newIndex =
      currentIndex < dataAnecdotas.length - 2 ? currentIndex + 2 : indices[0];
    setCurrentIndex(newIndex);
    setActivo((prev) => (prev === indices.length ? 1 : prev + 1));
  };

  const prevSlides2 = () => {
    let newIndex =
      currentIndex === indices[0] ? dataAnecdotas.length - 2 : currentIndex - 2;
    setCurrentIndex(newIndex);
    setActivo((prev) => (prev === 1 ? indices.length : prev - 1));
  };

  return (
    <div className="SB_anecdotas_contenido">
      <div className="SB_anecdotas_contenido_card_btn">
        <button className="btn-preview" onClick={prevSlides}>
          <img src={flecha_izq} alt="preview" />
        </button>
      </div>

      {itemsToShow.map((index) => (
        <div
          key={index}
          className="SB_anecdotas_contenido_card"
          id={
            dataAnecdotas[(index + dataAnecdotas.length) % dataAnecdotas.length]
              .id
          }
        >
          <div className="SB_anecdotas_contenido_card-img">
            <img
              src={
                dataAnecdotas[
                  (index + dataAnecdotas.length) % dataAnecdotas.length
                ].img
              }
              onClick={() =>
                openVideoPopup(
                  dataAnecdotas[
                    (index + dataAnecdotas.length) % dataAnecdotas.length
                  ].video
                )
              }
            />
          </div>
          <div className="SB_anecdotas_contenido_card-titulo">
            <h3>
              {t(
                `anecdotas.${
                  dataAnecdotas[
                    (index + dataAnecdotas.length) % dataAnecdotas.length
                  ].title
                }`
              )}
            </h3>
          </div>
        </div>
      ))}

      <div className="SB_anecdotas_contenido_card_btn">
        <button className="btn-next" onClick={nextSlides}>
          <img src={flecha_der} alt="preview" />
        </button>
      </div>

      {/* Flechas y paginacion movil */}
      <div className="SB_paginacion_flechas">
        <button className="btn-preview" onClick={prevSlides2}>
          <img src={flecha_izq} alt="preview" />
        </button>
        <div className="container_paginacion">
          {pages.map((page) => (
            <a
              key={page}
              className={page === activo ? `activo` : ""}
              onClick={() => goToPage(page)}
            >
              {page}
            </a>
          ))}
        </div>

        <button className="btn-next" onClick={nextSlides2}>
          <img src={flecha_der} alt="preview" />
        </button>
      </div>
    </div>
  );
};

export default Slider;
